import qs from 'qs'
import { buildCurlCommand } from '../../curl-command'
import { SelectedValueReportingFacet } from '../../../graphql/schema/types/value-reporting'

interface ValueReportingCurlOptions {
  readonly protocolAndHost: string
  readonly organizationUuid: string
  readonly authHeader: string
  readonly apiKey: string
  readonly facets?: SelectedValueReportingFacet[]
  readonly queryParameters?: {}
}
interface ValueReportingCurlConstantOptions {
  readonly pathSuffix: string
}

function buildVrCurlCommand({
  protocolAndHost,
  organizationUuid,
  pathSuffix,
  authHeader,
  apiKey,
  facets,
  queryParameters
}: ValueReportingCurlOptions & ValueReportingCurlConstantOptions) {
  const params = qs.stringify(queryParameters, { addQueryPrefix: true })

  return buildCurlCommand({
    protocolAndHost,
    method: 'POST',
    path: `/api/ng/organizations/${organizationUuid}${pathSuffix}${params}`,
    headers: {
      Authorization: authHeader,
      'Api-Key': apiKey,
      'Content-Type': 'application/json'
    },
    body: facets?.length ? { facets } : undefined
  })
}

const buildCommand =
  (constantOptions: ValueReportingCurlConstantOptions) =>
  (options: ValueReportingCurlOptions) =>
    buildVrCurlCommand({ ...constantOptions, ...options })

export const getApplicationRatingCurlCommand = buildCommand({
  pathSuffix: '/application-security-summary/ratings'
})
export const getVulnerabilityHistogramCurlCommand = buildCommand({
  pathSuffix: '/application-security-summary/vulnerabilities'
})
export const getRouteCoverageCurlCommand = buildCommand({
  pathSuffix: '/application-security-summary/routes'
})
export const getLicensesCurlCommand = buildCommand({
  pathSuffix: '/application-security-summary/licenses'
})
export const getOpenClosedVulnsCurlCommand = buildCommand({
  pathSuffix: '/application-security-summary/vulnerabilities/trends'
})
